import { usePermissions } from '@customerio/hydra-permissions/react';

// Permission questions that need a name: the answer combines permissions, or the
// name stops the check being written the wrong way round. For a plain gate, call
// `usePermissions()` at the site.

/**
 * Whether the user can send a test event.
 *
 * The back end authorizes `POST /events` on test_events/send OR imports/create
 * (HasOneOf, services ui_api/events/router.go). A control that checks only
 * test_events/send is disabled for users the back end accepts (SPE-3856).
 */
export function useCanSendTestEvent(): boolean {
  const { hasAnyPermission } = usePermissions();

  return hasAnyPermission('journeys/test_events/send', 'journeys/imports/create');
}

/**
 * Whether to hide sensitive attribute values from the user.
 *
 * Uses the permission, not the role name: a role name carries no masq state and
 * no account permissions.
 */
export function useIsRedacted(): boolean {
  const { hasPermission } = usePermissions();

  return !hasPermission('journeys/sensitive_data/view');
}
